<template>
  <div class="list">
    <div class="breadcrumb">
      <Breadcrumb>
        <Breadcrumb-item>老师管理</Breadcrumb-item>
        <Breadcrumb-item>推荐老师记录</Breadcrumb-item>
      </Breadcrumb>
    </div>
    <div class="search" @keyup.enter="search">
      <Form :label-width="80" :show-message="false">
        <Row :gutter="12">
          <Col  :xs="12" :sm="8" :md="6">
            <FormItem label="推荐人ID：">
              <el-input name="inviteId"
                     v-model="queryParam.inviteId" clearable></el-input>
            </FormItem>
          </Col>
          <Col  :xs="12" :sm="8" :md="6">
            <FormItem label="老师账号：">
              <el-input name="account" placeholder="支持模糊搜索"
                     v-model="queryParam.account" clearable></el-input>
            </FormItem>
          </Col>
          <Col  :xs="12" :sm="8" :md="6">
            <FormItem label="老师昵称：">
              <el-input name="nickname" placeholder="支持模糊搜索"
                     v-model="queryParam.nickname" clearable></el-input>
            </FormItem>
          </Col>
          <Col :xs="12" :sm="8" :md="4">
            <el-button type="primary" :loading="searchLoading" :disable="searchLoading" icon="search"
                    @click="search" >搜索</el-button>
          </Col>
        </Row>
      </Form>
    </div>
    <List ref="dataList" :tableColumns="title" :reload="reload" listUrl="/tch/recommend/list"
      :params="queryParam" :onLoading="onLoading" operator=""></List>
  </div>
</template>
<script>
import { fetchTchScoreMap, applyTchScoresToRows, renderTchNameWithScore } from '@/utils/tchScore'

  export default {
    data () {
      return {
        searchLoading: false,
        reload: 0,
        rankScoreSeq: 0,
        queryParam: {
          inviteId: null,
          account: '',
          nickname: ''
        },
        title: [
          {
            title: '老师ID',
            width: 150,
            key: 'newTchId'
          },
          {
            title: '老师昵称',
            width: 180,
            render: (h, params) => {
              let row = params.row
              return renderTchNameWithScore(h, {
                text: (row.firstName || '') + (row.lastName || ''),
                score: row.monthRankScore
              })
            }
          },
          {
            title: '老师账号',
            width: 150,
            key: 'account'
          },
          {
            title: '推荐人',
            width: 200,
            render: (h, params) => {
              let row = params.row
              return h('span', row.inviteId + '-' + row.referrerFirstName + row.referrerLastName)
            }
          },
          {
            title: '注册时间',
            width: 200,
            align: 'center',
            key: 'gmtCreate'
          },
        ]
      }
    },
    mounted: function () {
    },
    created: function () {
    },
    methods: {
      search () {
        this.reload = new Date().getTime()
      },
            onLoading (loading) {
        this.searchLoading = loading
        if (!loading) {
          this.loadMonthRankScores()
        }
      },
      loadMonthRankScores () {
        const table = this.$refs.dataList && this.$refs.dataList.tableData
        if (!table || !table.length) {
          return
        }
        const ids = table.map(function (row) { return row.newTchId }).filter(function (id) { return id != null })
        const seq = ++this.rankScoreSeq
        const self = this
        fetchTchScoreMap(this.$http, ids).then(function (map) {
          if (seq !== self.rankScoreSeq) {
            return
          }
          applyTchScoresToRows(self, table, 'newTchId', 'monthRankScore', map)
        })
      },
    }
  }
</script>



// WEBPACK FOOTER //
// TchRecommendList.vue?ad998986